import type { SignatureState, SigningUrlResult } from '../types'

export const normalizeSignatureStatus = (status?: string | null) => {
  const normalized = status?.trim().toUpperCase()
  return normalized || null
}

export const getSignatureStatus = (state: SignatureState) => {
  return normalizeSignatureStatus(state.signatureStatus ?? state.docuSignStatus)
}

export const getSigningUrl = (state: SigningUrlResult) => {
  return state.signingUrl ?? state.embeddedSigningUrl ?? state.url ?? null
}

export const hasSignedEnrollmentAgreement = (state: SignatureState) => {
  const status = getSignatureStatus(state)
  return state.enrollmentAgreementSigned === true || status === 'SIGNED' || status === 'COMPLETED'
}

export const shouldRestartSigningFlow = (state: SignatureState) => {
  const status = getSignatureStatus(state)
  return (
    state.enrollmentAgreementSigned !== true &&
    (status === 'CANCELLED' ||
      status === 'CANCELED' ||
      status === 'DECLINED' ||
      status === 'VOIDED' ||
      status === 'EXPIRED')
  )
}
